module.exports = __webpack_public_path__ + "img/kasasa-logo.65397628.png";